const capitalizeStr = (str: string) => {
  if (!str) return str;
  const loweredStr = str.toLowerCase();
  return `${loweredStr[0].toUpperCase()}${loweredStr.slice(1)}`;
};

const capitalizeWords = (str?: string): string => {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const kebabToCamelCase = (str: string) => {
  return str.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
};

const toKebabCase = (str: string) =>
  str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();

function camelToKebab(str: string) {
  return str.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}

const humanizeFieldKey = (str: string) => {
  const spaced = str
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .trim();
  return spaced
    .split(/\s+/)
    .map((word) => capitalizeStr(word))
    .join(" ");
};

const breakLongWord = (text?: string, chunkSize = 12): string | undefined => {
  if (!text) return text;
  return text
    .split(/(\s+)/)
    .map((token) =>
      /\s/.test(token) || token.length <= chunkSize
        ? token
        : (token.match(new RegExp(`.{1,${chunkSize}}`, "g")) ?? [token]).join(
            "",
          ),
    )
    .join("");
};

export {
  breakLongWord,
  camelToKebab,
  capitalizeStr,
  capitalizeWords,
  humanizeFieldKey,
  kebabToCamelCase,
  toKebabCase,
};
